import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const Step1PersonalInfo = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Personal Information</h3>
        <p className="text-gray-600">Please provide your personal details</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="first_name">First Name *</Label>
          <Input
            id="first_name"
            value={formData.first_name}
            onChange={(e) => handleChange('first_name', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="middle_name">Middle Name</Label>
          <Input
            id="middle_name"
            value={formData.middle_name}
            onChange={(e) => handleChange('middle_name', e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="last_name">Last Name *</Label>
          <Input
            id="last_name"
            value={formData.last_name}
            onChange={(e) => handleChange('last_name', e.target.value)}
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="preferred_name">Preferred Name (if different)</Label>
        <Input
          id="preferred_name"
          value={formData.preferred_name}
          onChange={(e) => handleChange('preferred_name', e.target.value)}
        />
      </div>

      <div className="space-y-4">
        <div>
          <Label htmlFor="address_line1">Address Line 1 *</Label>
          <Input
            id="address_line1"
            value={formData.address_line1}
            onChange={(e) => handleChange('address_line1', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="address_line2">Address Line 2 (if applicable)</Label>
          <Input
            id="address_line2"
            value={formData.address_line2}
            onChange={(e) => handleChange('address_line2', e.target.value)}
          />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="city">City *</Label>
          <Input
            id="city"
            value={formData.city}
            onChange={(e) => handleChange('city', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="state">State *</Label>
          <Input
            id="state"
            value={formData.state}
            onChange={(e) => handleChange('state', e.target.value)}
            placeholder="PA"
            required
          />
        </div>
        <div>
          <Label htmlFor="zip_code">ZIP Code *</Label>
          <Input
            id="zip_code"
            value={formData.zip_code}
            onChange={(e) => handleChange('zip_code', e.target.value)}
            required
          />
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="telephone">Telephone Number *</Label>
          <Input
            id="telephone"
            type="tel"
            value={formData.telephone}
            onChange={(e) => handleChange('telephone', e.target.value)}
            required
          />
        </div>
        <div>
          <Label htmlFor="email">Email Address *</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            required
          />
        </div>
      </div>

      <div>
        <Label htmlFor="date_of_birth">Date of Birth (MM/DD/YYYY) *</Label>
        <Input
          id="date_of_birth"
          type="date"
          value={formData.date_of_birth}
          onChange={(e) => handleChange('date_of_birth', e.target.value)}
          required
        />
      </div>
    </div>
  );
};

export default Step1PersonalInfo;